// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__3Fuoi","item":"PaymentsMobile_item__1waxJ","label":"PaymentsMobile_label__1_4hv","amount":"PaymentsMobile_amount__3tkdQ"};